<template>
  <div>

    <full-page :options="options" @after-load="afterLoad" @on-leave="checkPage" id="fullpage">

      <!--
      <div data-current="1" class="section section1">
            <img src="/src/assets/images/1sttop.png" alt="decal" class="top">
            <div class="mid"></div>
            <img src="/src/assets/images/title-text.png" alt="text" class="centering relative">
            <img src="/src/assets/images/1stbot.png" alt="decal" class="bottom">
            <div class="downbox" @click="goToPageSilently( next )">
              <img src="/src/assets/images/black-down.png">
            </div>
      </div> -->


      <div data-current="1" class="section section2">
            <img src="/src/assets/images/1sttop.png" alt="decal" class="top">
            <div class="mid"></div>
            <img src="/src/assets/images/title-text-shadow.png" alt="decal" class="centering relative">
            <img src="/src/assets/images/1stbot.png" alt="decal" class="bottom">
            <div class="downbox" @click="goToPage( next )">
              <img src="/src/assets/images/black-down.png">
            </div>
      </div>


      <div data-current="2" class="section section3">

        <div class="header-text first">
          <h1>OUR SIDE: <span class="tiny">ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN</span></h1>
          <hr>
        </div>
        <div class="upbox" @click="goToPage( last )">
          <img src="/src/assets/images/black-down.png">
        </div>

        <div class="row">
          <div class="column">
            <h2>A COMMON ORIGIN.</h2>
             <p>Several hundred years ago, the Apsáalooke [Crow] and Hidatsa were one tribe. During their migration from what is now Canada to new territories, the Crow left to find their own territory in a search that took some hundred years. “Bíiluuke,” meaning “our side” refers to the historical separation of the two tribes.</p>
              <!--<img src="/src/assets/video/thumbnail-1.jpg" class="box-top thumbnail" @click="play1()">-->
              <div id="video-box-1">
              <video controls width="100%" >
          			<source type="video/mp4" data-src="/src/assets/video/1.mp4">
          		</video>
              </div>
            </div>
          </div>

          <div class="footer-arrow" @click="goToPage( next )" >
            <img src="/src/assets/images/red-down.png">
          </div>

      </div>


      <div data-current="3" class="section section4">

        <div class="header-text">
          <h1>OUR SIDE: <span class="tiny">ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN</span></h1>
          <hr>
        </div>
        <div class="upbox" @click="goToPage( last )">
          <img src="/src/assets/images/black-down.png">
        </div>

        <div class="row theme-dark box squeeze">
          <div class="column">
            <p>Curator Red Star was raised on the Apsáalooke (Crow) Reservation in Montana. Her cultural heritage informs and inspires work that confronts colonial histories and romanticized characterizations of American Indians.</p>
            <p>“In my curatorial statement, I tell the origin story of the Crow people. The term Bíiluuke, which means, ‘I’m Crow and this is our side,’ describes my approach. I wanted to share this story with each artist, so that they would in turn share their stories and the stories of their people,” says Red Star.</p>
            <p>The exhibit invites Elisa Harkins, Tanya Lukin Linklater, Marianne Nicolson, and Tanis Maria S’eiltin, to react to the complicated history of colonialism while using the metaphor of thread and stitching to present their personal and tribal histories through a variety of mediums.</p>
          </div>
        </div>
        <div class="row two theme-dark strip squeeze">
          <div class="columm">
            <img src="/src/assets/images/Slikati-Missoula-Photographers-2017-25131932.jpg" alt="weird vampire shirt.jpg" class="display-image">
          </div>
          <div class="column">
            <p>Red Star organized the exhibition to honor her commitment, as she says “to create new forums for the expression of Native women’s voices in contemporary art.” The exhibition upholds MAM's dedication to presenting and collecting artworks by contemporary American Indian artists.</p>
            <p>“[In the exhibition] there’s a lot of different connections—language, global trade, origin stories— and I based the show off of a Crow origin story, and came up with the title Bíiluuke, our side.</p>
            <p>“To be Bíiluuke—‘OUR SIDE’—implies that one has the same ancestry, language, spiritual beliefs, territory, and social structure. From this term, which my ancestors used to define themselves as a separate unique people, this exhibition, our side, invites four contemporary artists: Elisa Harkins, Tanya Lukin Linklater, Marianne Nicolson, and Tanis S’eiltin to creatively investigate identity, language, and territory from their individual perspectives.”</p>
            <!--<a href="/" class="cta">READ RED STAR’S FULL CURATORIAL STATEMENT<img src="/src/assets/images/black-down.png"></a>-->
            <p class="right">—Wendy Red Star, Curator</p>
          </div>
        </div>

        <div class="footer-arrow" @click="goToPage( next )" >
          <img src="/src/assets/images/red-down.png">
        </div>


      </div>


      <div data-current="4" class="section section5">
        <div class="header-text">
          <h1>OUR SIDE: <span class="tiny">ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN</span></h1>
          <hr>
        </div>
        <div class="upbox" @click="goToPage( last )">
          <img src="/src/assets/images/black-down.png">
        </div>

        <div class="gallery box-top">
          <div class="gallery-window">
            <img src="/src/assets/images/gallery.jpg">
            <img src="/src/assets/images/gallery1.jpg">
            <img src="/src/assets/images/gallery2.jpg">
            <img src="/src/assets/images/gallery3.jpg">
          </div>
          <p class="centering strip bold">Our Side Exhibit and Panel.</p>

        </div>
        <div class="shoutbox theme-main">
          <div class="row box">
            <div class="column centering white">
              <h3>“The conversation that unfolds during the <strong>OUR SIDE</strong> exhibition is one that has been missing, but is one of the most important conversations we could have.”</h3>
              <p>-Brandon Reintjes, MAM Senior Curator</p>
              <p class="strip">This exhibition and publication at the Missoula Art Museum have been generously supported by the Andy Warhol Foundation for the Visual Arts.</p>
            </div>
          </div>
        </div>
        <div class="footer-arrow" @click="goToPage( next )" >
          <img src="/src/assets/images/red-down.png">
        </div>
      </div>


      <div data-current="5" class="section section6">

        <div class="header-text">
          <h1>OUR SIDE: <span class="tiny">ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN</span></h1>
          <hr>
        </div>
        <div class="upbox" @click="goToPage( last )">
          <img src="/src/assets/images/black-down.png">
        </div>

        <div class="row">
          <div class="column">
            <img src="/src/assets/video/thumbnail-2.jpg" class="thumbnail" @click="play2()">
          </div>
        </div>
        <div class="row two">
          <div class="column">
            <h3 class="white">OUR SIDE: Panel Discussion Excerpts</h3>
          </div>
          <div class="column">
            <a href="https://vimeo.com/259384951/42ae8a820f" class="cta" target="_blank">WATCH THE FULL PANEL DISCUSSION<img src="/src/assets/images/black-down.png"></a>
          </div>
        </div>
        <div class="footer-arrow" @click="goToPage( next )" >
          <img src="/src/assets/images/blue-down.png">
        </div>
      </div>


      <div data-current="6" class="section section7">

        <div class="header-text">
          <h1>OUR SIDE: <span class="tiny">ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN</span></h1>
          <hr>
        </div>
        <div class="upbox" @click="goToPage( last )">
          <img src="/src/assets/images/black-down.png">
        </div>

        <div class="row">
          <div class="column">
            <h1 class="ani">THE ARTWORK.</h1>
            <p>This reconsideration of the groundbreaking exhibition <strong>Women of Sweetgrass, Cedar and Sage</strong>, curated by Harmony Hammond and Jaune Quick- to-See Smith on its thirtieth anniversary, offers a re-visitation of the landscape of contemporary American Indian art, and a reconsideration of the opportunities afforded to Native women artists.</p>
            <p>Each artist created work using a broad range of media including performance, sculpture, painting, sound, social engagement and video.</p>
            <div class="qoute">
              <p>“The works weave back and forth into each other really beautifully,” says curator Wendy Red Star, “All speak and have a conversation, and there’s room for them also to breathe and speak on their own.”</p>
            </div>
            <h1 class="mate">THE ARTISTS.</h1>
            <p>The artists brought together in <strong>OUR SIDE</strong> have, in many important regards, a common bedrock of experience—whether through gender, culture, politics, assimilation or resistance—which informs their discrete artistic practices. These women are,  first and foremost, artists who are highly attuned to the tensions embedded in their work as visual translators of both their contemporary existence and their cultural inheritance. Each, in her own way, navigates a variety of media to express and question and the contested historical meanings of Native identity, geography and home.</p>
          </div>
        </div>

        <div class="footer-arrow" @click="goToPage( next )" >
          <img src="/src/assets/images/red-down.png">
        </div>
      </div>


      <div data-current="7" class="section section8">

        <div class="header-text">
          <h1>OUR SIDE: <span class="tiny">ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN</span></h1>
          <hr>
        </div>
        <div class="upbox" @click="goToPage( last )">
          <img src="/src/assets/images/black-down.png">
        </div>

        <div class="slide">
          <div class="row five">
            <div class="three columns">
              <h1>ELISA HARKINS</h1>
              <p class="box justify">Harkins, a composer and artist originally from Miami, Oklahoma, is an enrolled member of the Muscogee (Creek) Nation. She uses the intersection of performance and lived experience through electronic music, sculpture, and the body to explore subjects such as adoption, enrollment, and the 1990 Indian Arts and Crafts Act.</p>
              <a href="/#7/3" class="cta">HEAR A DESCRIPTION OF THE ARTIST’S WORK <img src="/src/assets/images/black-down.png"></a>
            </div>
            <div class="two columns">
              <img src="/src/assets/images/elisa.jpg" alt="Elisa Harkins" class="display-image">
            </div>
          </div>



        </div>
        <div class="slide">
          <div class="row">
            <div class="column">
              <img src="/src/assets/video/thumbnail-3.jpg" class="thumbnail" @click="play3()">
            </div>
          </div>

          <div class="row six">
            <div class="three columns">
              <h3 class="white">OUR SIDE: Elisa Harkins, Wampum</h3>
            </div>
            <div class="two columns push-one">
              <a href="https://vimeo.com/259384951/42ae8a820f" class="cta" target="_blank">WATCH THE FULL VIDEO<img src="/src/assets/images/black-down.png"></a>
            </div>
          </div>
        </div>
        <div class="slide">
          <div class="row three">
            <div class="column">
              <img src="/src/assets/images/1st.jpg" alt="Elisa Art" class="display-image">
            </div>
            <div class="two columns">
              <img src="/src/assets/images/elisa-gallery.jpg" alt="Elisa Gallery" class="display-image">
            </div>
          </div>
          <p class="centering strip">Elisa Harkins, <span class="art">Fake Part 1</span>, fabric, feathers, beads, horsehair, 2014.</p>
        </div>
        <div class="slide">
          <div class="row">
            <div class="column">
              <img src="/src/assets/video/thumbnail-4.jpg" class="thumbnail" @click="play4()">
            </div>
          </div>

          <div class="row six">
            <div class="three columns">
              <h3 class="white">OUR SIDE: Elisa Harkins</h3>
            </div>
            <div class="two columns push-one">
              <a href="https://vimeo.com/259384951/42ae8a820f" class="cta" target="_blank">WATCH THE FULL VIDEO<img src="/src/assets/images/black-down.png"></a>
            </div>
          </div>
        </div>

        <div class="box artist">
          <div class="column centering white">
            <hr><h2>Elisa Harkins</h2>
          </div>
        </div>
        <div class="footer-arrow" @click="goToPage( next )" >
          <img src="/src/assets/images/red-down.png">
        </div>
      </div>


      <div data-current="8" class="section section9">

        <div class="header-text">
          <h1>OUR SIDE: <span class="tiny">ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN</span></h1>
          <hr>
        </div>
        <div class="upbox" @click="goToPage( last )">
          <img src="/src/assets/images/black-down.png">
        </div>

        <div class="slide">
          <div class="row two">
            <div class="column">
              <h1>TANYA LUKIN LINKLATER</h1>
              <p class="box justify">Linklater, originating from the Native Village of Afognak and Port Lions in southern Alaska and based in northern Ontario, Canada, exhibits her performance collaborations, videos, and installations internationally. Relationships between bodies, histories, poetry, pedagogy, Indigenous conceptual spaces and languages, and institutions are the compelling themes in her work.</p>
              <a href="/#8/3" class="cta">HEAR A DESCRIPTION OF THE ARTIST’S WORK <img src="/src/assets/images/black-down.png"></a>
            </div>
            <div class="column">
              <img src="/src/assets/images/tanya-1.jpg" alt="Tanya Art">
              <p>Tanya Lukin Linklater, <span class="art">The treaty is in the body</span>, wooden tables, Delica beads, American Spirit cigarettes, 2013–2017.</p>
            </div>
          </div>
        </div>
        <div class="slide middle">
          <div class="row seven">
            <div class="three columns">
              <img src="/src/assets/images/tanya-2.jpg" alt="Tanya Art">
              <p class="centering strip">Tanya Lukin Linklater, <span class="art">The Harvest Sturdies</span>, banners with text, 2013–2017.</p>

            </div>
            <div class="three push-one columns">
              <img src="/src/assets/images/tanya-3.jpg" alt="Tanya Art">
              <p class="centering strip">Tanya Lukin Linklater, <span class="art">The treaty is in the body</span>, wooden tables, Delica beads, American Spirit cigarettes, 2013–2017.</p>
            </div>
          </div>
        </div>
        <div class="slide vert-top">
          <div class="row six">
            <div class="four columns push-one">
              <!-- <img src="/src/assets/images/tanya-4.jpg" alt="Tanya Art">
              <p class="centering strip"></p> -->
              <div class="gallery poems">
                <div class="gallery-window">
                  <img src="/src/assets/images/poem1.jpg">
                  <img src="/src/assets/images/poem2.jpg">
                  <img src="/src/assets/images/poem3.jpg">
                  <img src="/src/assets/images/poem4.jpg">
                  <img src="/src/assets/images/poem5.jpg">
                  <img src="/src/assets/images/poem6.jpg">
                  <img src="/src/assets/images/poem7.jpg">
                  <img src="/src/assets/images/poem8.jpg">
                </div>
                <p class="centering strip">Tanya Lukin Linklater, <span class="art">The Harvest Sturdies</span>, banners with text, 2013–2017.</p>

              </div>
            </div>
          </div>
        </div>
        <div class="slide middle">
          <div class="row">
            <div class="column">
              <img src="/src/assets/video/thumbnail-5.jpg" class="thumbnail" @click="play5()">
            </div>
          </div>
          <div class="row two">
            <div class="column">
              <h3 class="white">OUR SIDE: Tanya Lukin Linklater</h3>
            </div>
            <div class="column">
              <a href="https://vimeo.com/259384951/42ae8a820f" target="_blank" class="cta">WATCH THE FULL PANEL DISCUSSION<img src="/src/assets/images/black-down.png"></a>
            </div>
          </div>
        </div>

        <div class="box artist">
          <div class="column centering white">
            <hr><h2>TANYA LUKIN LINKLATER</h2>
          </div>
        </div>
        <div class="footer-arrow" @click="goToPage( next )" >
          <img src="/src/assets/images/red-down.png">
        </div>
      </div>


      <div data-current="9" class="section section10">

        <div class="header-text">
          <h1>OUR SIDE: <span class="tiny">ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN</span></h1>
          <hr>
        </div>
        <div class="upbox" @click="goToPage( last )">
          <img src="/src/assets/images/black-down.png">
        </div>

        <div class="slide">
          <div class="row two">
            <div class="column mobile-second">
              <img src="/src/assets/images/marianne-1.jpg" alt="Marianne Art">
              <p class="centering">Marianne Nicolson/‘Tayagila’ogwa, <span class="art">La'am'lawisuxw ya'xuxsan's 'nalax (Then the Deluge of Our World Came)</span>, acrylic and brass on wood, 2017.</p>
            </div>
            <div class="column mobile-first">
              <h1>MARIANNE NICOLSON</h1>
              <p class="box justify">Nicolson (‘Tayagila’ogwa), is an artist of Scottish and Dzawada’enuxw First Nations descent. The Dzawada’enuxw People are a member tribe of the Kwakwaka’wakw Nations of the Paci c Northwest Coast. Nicolson’s practice encompasses both traditional Kwakwaka’wakw forms and culture and Western art practice to engage issues of Aboriginal histories and politics arising from a passionate involvement in cultural revitalization and sustainability.</p>
              <a href="/#9/2" class="cta">HEAR A DESCRIPTION OF THE ARTIST’S WORK <img src="/src/assets/images/black-down.png"></a>
            </div>

          </div>
        </div>
        <div class="slide middle">
          <div class="row">
            <div class="column">
              <img src="/src/assets/images/gallery.jpg" alt="Marianne Art">
              <p class="centering strip">Marianne Nicolson/‘Tayagila’ogwa, <span class="art">La'am'lawisuxw ya'xuxsan's 'nalax (Then the Deluge of Our World Came)</span>, acrylic and brass on wood, 2017.</p>
            </div>
          </div>
        </div>
        <div class="slide middle">
          <div class="row">
            <div class="column">
              <img src="/src/assets/video/thumbnail-6.jpg" class="thumbnail" @click="play6()">
            </div>
          </div>
          <div class="row two">
            <div class="column">
              <h3>OUR SIDE: Marianne Nicolson</h3>
            </div>
            <div class="column">
              <a href="https://vimeo.com/259384951/42ae8a820f" class="cta" target="_blank">WATCH THE FULL PANEL DISCUSSION<img src="/src/assets/images/black-down.png"></a>
            </div>
          </div>
        </div>

        <div class="box artist">
          <div class="column centering light">
            <hr><h2>MARIANNE NICOLSON</h2>
          </div>
        </div>
        <div class="footer-arrow" @click="goToPage( next )" >
          <img src="/src/assets/images/red-down.png">
        </div>

      </div>


      <div data-current="10" class="section section11">

        <div class="header-text">
          <h1>OUR SIDE: <span class="tiny">ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN</span></h1>
          <hr>
        </div>
        <div class="upbox" @click="goToPage( last )">
          <img src="/src/assets/images/black-down.png">
        </div>

        <div data-current="11" class="slide">
          <div class="row two">
            <div class="column mobile-second">
              <img src="/src/assets/images/tanis-1.jpg" alt="Tanis Art">
              <p class="centering">Tanis Maria S’eiltin, <span class="art">Untitled</span>, merino wool felt, thread, metal grommets and snaps, fresh water pearls, 2017.</p>
            </div>
            <div class="column mobile-first">
              <h1>TANIS MARIA S’EILTIN</h1>
              <p class="box justify">S’eiltin grew up in Alaska in a family of artists, where she learned traditional weaving and skin-sewing techniques and is a professor at Western Washington University in Bellingham, WA.</p>
              <a href="/#10/3" class="cta">HEAR A DESCRIPTION OF THE ARTIST’S WORK <img src="/src/assets/images/black-down.png"></a>
            </div>
          </div>
        </div>
        <div class="slide">
          <div class="row seven">
            <div class="two columns">
              <img src="/src/assets/images/tanis-2.jpg" alt="Tanis Art" class="display-image">
            </div>
            <div class="three columns">
              <img src="/src/assets/images/tanis-3.jpg" alt="Tanis Art" class="display-image no-mobile">
            </div>
            <div class="two columns">
              <img src="/src/assets/images/tanis-4.jpg" alt="Tanis Art" class="display-image">
            </div>
          </div>
          <p class="centering strip">Tanis Maria S’eiltin, <span class="art">Untitled</span>, merino wool felt, thread, metal grommets and snaps, fresh water pearls, 2017.</p>
        </div>
        <div class="slide middle">
          <div class="row two">
            <div class="column centering">
              <img src="/src/assets/images/tanis-5.jpg" alt="Tanis Art">
              <p>Tanis Maria S’eiltin, <span class="art">Steam Punk Raven Flies to the North Star</span>, wool felt, glass beads, grommets, thread, 2017.</p>
            </div>
            <div class="column centering">
              <img src="/src/assets/images/tanis-6.jpg" alt="Tanis Art">
              <p>Tanis Maria S’eiltin, <span class="art">People of the Tide: Raven, Coho, Octopus</span>, wool felt, leather, glass beads, grommets, thread, 2017.</p>
            </div>
          </div>
        </div>
        <div class="slide middle">
          <div class="row">
            <div class="column">
              <img src="/src/assets/video/thumbnail-7.jpg" class="thumbnail" @click="play7()">
            </div>
          </div>
          <div class="row two">
            <div class="column">
              <h3 class="white">OUR SIDE: Tanis Maria S’eiltin</h3>
            </div>
            <div class="column">
              <a href="https://vimeo.com/259384951/42ae8a820f" class="cta" target="_blank">WATCH THE FULL PANEL DISCUSSION<img src="/src/assets/images/black-down.png"></a>
            </div>
          </div>
        </div>

        <div class="box artist">
          <div class="column centering white">
            <hr><h2>TANIS MARIA S’EILTIN</h2>
          </div>
        </div>
        <div class="footer-arrow" @click="goToPage( next )" >
          <img src="/src/assets/images/blue-down.png">
        </div>
      </div>


      <div data-current="11" class="section section12">

        <div class="header-text">
          <h1>OUR SIDE: <span class="tiny">ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN</span></h1>
        </div>
        <div class="upbox" @click="goToPage( last )">
          <img src="/src/assets/images/black-down.png">
        </div>

        <div class="row eight">
          <div class="six columns push-one">
            <a href="http://www.missoulaartmuseum.org/" target="_blank"><img src="/src/assets/images/logo.png" class="logo centering"></a>
            <p class="bold">OUR SIDE is a testament to MAM’s purpose.</p>
            <p>One of MAM’s abiding mottos is “Free Expression//Free Admission.” We believe that freedom of expression, freedom of thought, intellectual inquiry, and cultural expression are the foundation of our democratic values. MAM develops exhibitions that are representations of these principles in action. Cultural work and human rights are closely aligned.</p>
            <p>MAM is committed to diversity and inclusion as a driver of institutional excellence. MAM seeks out diversity of participation, thought and action.</p>
          </div>
        </div>
        <div class="footer-arrow" @click="goToPage( next )" >
          <img src="/src/assets/images/blue-down.png">
        </div>

      </div>
      <div data-current="12" class="section section13">

        <div class="header-text">
          <h1>OUR SIDE: <span class="tiny">ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN</span></h1>
        </div>
        <div class="upbox" @click="goToPage( last )">
          <img src="/src/assets/images/black-down.png">
        </div>

        <div class="theme-secondary">
          <div class="row six box">
            <div class="two columns">
              <img src="/src/assets/images/book.jpg" alt="Buy the book!" class="display-image">
            </div>

            <div class="four columns white">
              <a href="http://www.missoulaartmuseum.org/index.php/type/catalog/ID/8f2f8c1aa0e4367f9e598f0e73f980af/fuseaction/buy.detail.htm" target="_blank"><h2 class="box">ORDER THE BOOK:</h2></a>
              <a href="http://www.missoulaartmuseum.org/index.php/type/catalog/ID/8f2f8c1aa0e4367f9e598f0e73f980af/fuseaction/buy.detail.htm" target="_blank">
                <h1>OUR SIDE: ELISA HARKINS, TANYA LUKIN LINKLATER MARIANNE NICOLSON + TANIS MARIA S’EILTIN</h1>
              </a>
              <p>Curated by Wendy Red Star</p>
              <p class="strip">Copyright © 2018 Missoula Art Museum | Photography copyright © 2017 <a href="http://slikati.com/" target="_blank">Slikati Photo + Video</a></p>
            </div>

          </div>
        </div>
        <div class="row six box">
          <div class="four columns push-one">
            <a href="mailto:brandon@missoulaartmuseum.org" class="cta">TO INQUIRE ABOUT THE TOURING EXHIBITION, CLICK HERE.<img src="/src/assets/images/black-down.png"></a>
          </div>
        </div>

      </div>

    </full-page>
    <!--
    <div class="modal" id="video-box-1" @click="closemodal()">
    	<div class="modal-content">
    		<video controls width="100%" >
    			<source type="video/mp4" data-src="/src/assets/video/1.mp4">
    		</video>
    	</div>
      <i class="ion-ios-close-outline" id="right"></i>
    </div> -->
    <div class="modal" id="video-box-2" @click="closemodal()">
    	<div class="modal-content">
    		<video controls width="100%">
    			<source data-src="/src/assets/video/2.mp4" type="video/mp4">
    		</video>
    	</div>
      <i class="ion-ios-close-outline" id="right"></i>
    </div>
    <div class="modal" id="video-box-3" @click="closemodal()">
    	<div class="modal-content">
    		<video controls width="100%">
    			<source data-src="/src/assets/video/3.mp4" type="video/mp4">
    		</video>
    	</div>
      <i class="ion-ios-close-outline" id="right"></i>
    </div>
    <div class="modal" id="video-box-4" @click="closemodal()">
    	<div class="modal-content">
    		<video controls width="100%">
    			<source data-src="/src/assets/video/4.mp4" type="video/mp4">
    		</video>
    	</div>
      <i class="ion-ios-close-outline" id="right"></i>
    </div>
    <div class="modal" id="video-box-5" @click="closemodal()">
    	<div class="modal-content">
    		<video controls width="100%">
    			<source data-src="/src/assets/video/5.mp4" type="video/mp4">
    		</video>
    	</div>
      <i class="ion-ios-close-outline" id="right"></i>
    </div>
    <div class="modal" id="video-box-6" @click="closemodal()">
    	<div class="modal-content">
    		<video controls width="100%">
    			<source data-src="/src/assets/video/6.mp4" type="video/mp4">
    		</video>
    	</div>
      <i class="ion-ios-close-outline" id="right"></i>
    </div>
    <div class="modal" id="video-box-7" @click="closemodal()">
    	<div class="modal-content">
    		<video controls width="100%">
    			<source data-src="/src/assets/video/7.mp4" type="video/mp4">
    		</video>
    	</div>
      <i class="ion-ios-close-outline" id="right"></i>
    </div>

  </div>
</template>

<script>
  import FullPage from './../FullPage.vue';
  import fullPageMixin from './../fullPageMixin';

  export default {
    mixins: [fullPageMixin],

    components: {
      FullPage,
    },

    data() {
      return {
        current: 1,
        next: 2,
        last: 1,
        options: {
          afterLoad: this.afterLoad,
          scrollBar: true,
          menu: '#menu',
          navigation: true,
          touchSensitivity: 50,
          responsiveWidth: 789,
          responsiveHeight: 789,
          anchors: ['1', '2', '3','4','5','6','7','8','9','10','11','12','13']
        },
      }
    },

    methods: {
      afterLoad() {
        this.current = $('.active.section').data('anchor');
        this.next = this.current + 1,
        this.last = this.current - 1,
        console.log( this.next + ' is the next page. ' + this.last + ' is the last page.');
        if(this.current == 2){
          this.play1();
        }

      },

        goToPage: function(page) {
          console.log('Scrolling to page' + page);
          $.fn.fullpage.moveTo(page);
        },

        goToPageSilently: function(page) {
          console.log('Scrolling to page' + page);
          $.fn.fullpage.silentMoveTo(page);
        },

        removeSection: function(){
            $('#fullpage').find('.fp-section').last().remove();
            this.options.anchors.pop();
            $('#menu').find('li').last().prev().remove();
        },

        toggleNavigation: function(){
            this.options.navigation = !this.options.navigation;
        },

        toggleScrollbar: function(){
            console.log("Changing scrollbar...");
            this.options.scrollBar = !this.options.scrollBar;
        },

        checkPage(){
          if(this.current == 1){
      			//$.fn.fullpage.silentMoveTo('page1', 'page2');
      		}

        },

        play1() {
          var sourceFile = $('#video-box-1 video source').attr('data-src');
          $('#video-box-1 video source').attr('src',sourceFile);
          $('#video-box-1 video').get(0).load();
          $('#video-box-1').css('opacity',1);
      		$('#video-box-1 video').get(0).play();
        },

        play2() {
          var sourceFile = $('#video-box-2 video source').attr('data-src');
          $('#video-box-2 video source').attr('src',sourceFile);
          $('#video-box-2 video').get(0).load();
          $('#video-box-2').css('display','block');
      		$('#video-box-2 video').get(0).play();
        },

        play3() {
          var sourceFile = $('#video-box-3 video source').attr('data-src');
          $('#video-box-3 video source').attr('src',sourceFile);
          $('#video-box-3 video').get(0).load();
          $('#video-box-3').css('display','block');
      		$('#video-box-3 video').get(0).play();
        },

        play4() {
          var sourceFile = $('#video-box-4 video source').attr('data-src');
          $('#video-box-4 video source').attr('src',sourceFile);
          $('#video-box-4 video').get(0).load();
          $('#video-box-4').css('display','block');
      		$('#video-box-4 video').get(0).play();
        },

        play5() {
          var sourceFile = $('#video-box-5 video source').attr('data-src');
          $('#video-box-5 video source').attr('src',sourceFile);
          $('#video-box-5 video').get(0).load();
          $('#video-box-5').css('display','block');
      		$('#video-box-5 video').get(0).play();
        },

        play6() {
          var sourceFile = $('#video-box-6 video source').attr('data-src');
          $('#video-box-6 video source').attr('src',sourceFile);
          $('#video-box-6 video').get(0).load();
          $('#video-box-6').css('display','block');
      		$('#video-box-6 video').get(0).play();
        },

        play7() {
          var sourceFile = $('#video-box-7 video source').attr('data-src');
          $('#video-box-7 video source').attr('src',sourceFile);
          $('#video-box-7 video').get(0).load();
          $('#video-box-7').css('display','block');
      		$('#video-box-7 video').get(0).play();
        },

        closemodal(){
          $('.modal').css('display','none');
          $('#video-box-1 video').get(0).pause();
          $('#video-box-2 video').get(0).pause();
          $('#video-box-3 video').get(0).pause();
          $('#video-box-4 video').get(0).pause();
          $('#video-box-5 video').get(0).pause();
          $('#video-box-6 video').get(0).pause();
          $('#video-box-7 video').get(0).pause();
          $('#video-box-8 video').get(0).pause();
        },

    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/Main.vue